/**
 * Copyright (c) 2021-22 Amway
 * @author Mohit Chunawala
 */

import React from "react";
import Button from "../shared-ui//button";
import { GETUSERTNCCONSENTAGREEMENT } from "../../queries/terms";
import ResultsHeader from "../shared-ui/results-header";
import Slider from "react-slick";
import Footer from "../shared-ui/footer";
import TermsConditions from "../terms-conditions";
import CartComponent from "../shared-ui/cart";
import { getContentFromContentStack } from "../../core/contentStack";
import ReactHtmlParser from "react-html-parser";
import _ from "lodash";
import { getShareableLink } from "../../services/aboToolsService";
import queryString from "query-string";
import MessageStrip from "../shared-ui/message-strip";
import {
  compareExpiryTime,
  compareGuestExpiryTime,
  setGuestExpiryTime,
  setGuestSaveResultTime,
} from "../../utils/handleExpiryTime";
import { clearSession } from "../../utils/clearSession";
import { handleRecoResultByRecoIdAPI } from "../../services/recommendationService";
import { handleGuestExpiryPopup } from "../../utils/handlePopups";
import { validateOktaSession } from "../../utils/validateOktaSession";
import { withOktaAuth } from "@okta/okta-react";
import SaveResultsPopup from "../shared-ui/popup/save-results";
import {
  getLanguage,
  removeHybrisSession,
} from "../../services/commerceServices/accessToken";
import { fetchLynxValueAttribution } from "../../services/commerceServices/attributionServices";
import Cookies from "js-cookie";
import { utag, withUtag } from "../analytics/analytics";
import i18n from "../../i18n";
import {
  getUtagAuthObject,
  getUtagNeedStates,
  getUtagSessionObject,
} from "../../utils/utagSession";
import PickSurveyComponent from "../achievers";

// Interface for HomeComponent State
interface HomeComponentState {
  isTermsVisible: boolean;
  isCartVisible: boolean;
  errorMsg: String;
  homePageContents: any;
  cardContent: any;
  isShareVisible: boolean;
  isAssessmentDone: boolean;
  isAssessmentContinued: boolean;
  successfullyCopied: boolean;
  t?: any;
  isPopupOpen: boolean;
  isSessionExpired: boolean;
  isGuestTimeExpired: boolean;
  visibleOnMobile: boolean;
  isCopLinkPopUpOpen: boolean;
  linkToBeCopied: string;
  isPickSurveyVisible: boolean;
  scientistsContent: any;
}

/**
 * Home Screen component.
 *
 * @namespace HomeComponent
 */
class HomeComponent extends React.Component<any, HomeComponentState> {
  constructor(props: any) {
    super(props);
    this.state = {
      isTermsVisible: false,
      isCartVisible: false,
      errorMsg: "",
      homePageContents: [],
      cardContent: [],
      isShareVisible: false,
      isAssessmentDone: false,
      successfullyCopied: false,
      isPopupOpen: false,
      isSessionExpired: false,
      isGuestTimeExpired: false,
      isAssessmentContinued: false,
      visibleOnMobile: false,
      isCopLinkPopUpOpen: false,
      linkToBeCopied: "",
      isPickSurveyVisible: false,
      scientistsContent: [],
    };
  }

  componentDidMount = () => {
    //testing meta reco by id API
    // handleMetaRecoResultAPIById("salka")
    //   .then((res) => {
    //     console.log("res is--->", res);
    //   })
    //   .catch((err: any) => {
    //     console.log(err);
    //   });
    // //testing list test scenarios
    // listTestScenarios()
    //   .then((res) => {
    //     console.log("list res is--->", res);
    //   })
    //   .catch((err: any) => {
    //     console.log(err);
    //   });
    const { search } = this.props.location;
    const { locale } = queryString.parse(search);
    if (!sessionStorage.getItem("languageTypeOfApp")) {
      const localLanguageType =
        (locale === "es-us" && "es-us") ||
        (locale === "en-us" && "en-us") ||
        "en-us";
      sessionStorage.setItem("languageTypeOfApp", localLanguageType);
      i18n.changeLanguage(localLanguageType);
    }
    //update to analytics
    let authObj = getUtagAuthObject();
    let sessionObj = getUtagSessionObject();
    let needStatesObj = getUtagNeedStates();
    // let obj = {
    //   page_name: "Home Page",
    //   event_name: "home_details",
    // };
    let updatedObj = _.merge(
      localStorage.getItem("user-info") ? authObj : {},
      localStorage.getObj("reco-result") ? needStatesObj : {},
      sessionObj
      // obj
    );
    withUtag().then((utag) => utag.view(updatedObj));
    //set attribution tokens
    // Create a media condition that targets viewports at least 768px wide
    if (localStorage.getItem("logout")) {
      removeHybrisSession();
      localStorage.removeItem("logout");
    }

    const mediaQuery = window.matchMedia("(max-width: 767px)").matches;
    if (mediaQuery) {
      this.setState({
        visibleOnMobile: true,
      });
    }
    this.handleShareLinkVisibility();
    this.handleAssesmentDoneButtonText();
    this.getHomePageData("ms_home_page");

    //check to validate user consent acceptence
    if (
      sessionStorage.getItem("before-login-consent") &&
      !this.state.isTermsVisible &&
      localStorage?.getObj("user-consent") !== "accepted"
    ) {
      this.setState({
        isTermsVisible: true,
      });
    }

    //fetch recommendations using reco-id of existing logged in user
    const reco_id = localStorage.getObj("reco-user-id");
    const foundationalPageCount = sessionStorage.getItem(
      "foundationalPageCount"
    );
    if (
      reco_id &&
      !foundationalPageCount &&
      localStorage.getItem("okta-token-storage")
    ) {
      handleRecoResultByRecoIdAPI(reco_id)
        .then((res: any) => {
          res && localStorage.setObj("reco-result", res);
          res &&
            this.setState({
              isAssessmentDone: true,
            });
        })
        .catch((err: any) => {
          console.log(err);
        });
    }

    //handles guest expiryTime case
    handleGuestExpiryPopup(this.props);
  };

  componentWillReceiveProps(props: any) {
    //getContentFormComponenet function is called here
    if (props && props.i18n.language) {
      this.getHomePageData("ms_home_page");
    }
  }

  componentDidUpdate = () => {
    validateOktaSession(this.props.oktaAuth);
    if (
      localStorage.getItem("guestExpiryTime") &&
      compareGuestExpiryTime() < 0
    ) {
      clearSession(this.props);
    }
    //enables login session expiry popup
    if (
      sessionStorage.getItem("login-session-expired") &&
      !this.state.isSessionExpired &&
      !(localStorage?.getItem("okta-token-storage") !== "{}")
    ) {
      this.setState({
        isSessionExpired: true,
        isPopupOpen: true,
      });
    }

    //handles guest time expiry popup
    if (
      sessionStorage.getItem("session-cleared") &&
      !this.state.isGuestTimeExpired
    ) {
      this.setState({
        isGuestTimeExpired: true,
        isPopupOpen: true,
      });
    }
  };

  /**
   * This method is used to handle continue button
   *
   */
  handleContinue = () => {
    this.props.client
      .query({
        query: GETUSERTNCCONSENTAGREEMENT,
        variables: {
          userId: "5",
        },
        fetchPolicy: "no-cache",
      })
      .then((res: any) => {
        const statusCode =
          res.data &&
          res.data.getUserTncConsentAgreement &&
          res.data.getUserTncConsentAgreement.code;

        const status =
          res.data &&
          res.data.getUserTncConsentAgreement &&
          res.data.getUserTncConsentAgreement.result &&
          res.data.getUserTncConsentAgreement.result[0].status;

        if (statusCode === 200) {
          if (status) {
            this.props.history.push("/foundational");
          } else {
            this.props.history.push("/terms");
          }
        } else {
          this.props.history.push("/terms");
        }
      })
      .catch((err: any) => {
        console.log(err);
        this.props.history.push("/terms");
      });
  };

  /**
   * This method is used to handle Survey button and result button as per
   * isAssessmentDone state.
   */
  handleTakeSurvey = () => {
    if (this.state.isAssessmentContinued) {
      //handles continue assessment
      this.props.history.push("/foundational");
    } else if (this.state.isAssessmentDone) {
      this.setState(
        {
          isPickSurveyVisible: false,
        },
        () => {
          const storageData = localStorage.getObj("results");
          // this.props.history.push("/results");
          this.props.history.push("/results", { data: storageData });
        }
      );
    } else {
      this.setState({
        isPickSurveyVisible: true,
      });
    }
    //update to analytics
    // let authObj = getUtagAuthObject();
    // let sessionObj = getUtagSessionObject();
    // let needStatesObj = getUtagNeedStates();

    // let obj = {
    //   page_name: "Home Page",
    //   event_name: "take_survey",
    // };
    // let updatedObj = _.merge(
    //   localStorage.getItem("user-info") ? authObj : {},
    //   localStorage.getObj("reco-result") ? needStatesObj : {},
    //   sessionObj,
    //   obj
    // );
    // withUtag().then((utag) => utag.link(updatedObj));
    // let userConsentFlag: any = localStorage.getObj("user-consent");
    // if (!this.state.isAssessmentDone) {
    //   // Call for Term and condition
    //   if (userConsentFlag && userConsentFlag === "accepted") {
    //     this.setState({
    //       isTermsVisible: false,
    //     });
    //     this.props.history.push("/foundational");
    //   } else {
    //     this.setState({
    //       isTermsVisible: true,
    //     });
    //   }
    //   // this.props.history.replace("/terms");
    // } else if (this.state.isAssessmentContinued) {
    //   //handles continue assessment
    //   this.props.history.push("/foundational");
    // } else {
    //   // call for the result page.

    //   //sets save result popup time for guest user
    //   if (!localStorage.getItem("okta-token-storage")) {
    //     setGuestSaveResultTime();
    //   }
    //   if (userConsentFlag && userConsentFlag === "accepted") {
    //     const storageData = localStorage.getObj("results");
    //     // this.props.history.push("/results");
    //     this.props.history.push("/results", { data: storageData });
    //   } else {
    //     localStorage.removeItem("reco-result");
    //     this.setState({
    //       isTermsVisible: true,
    //     });
    //   }
    // }
  };
  /*handleTakeSurveyOnKeyPress = (event: any) => {
    if (event.key === "Enter" || event.key === " ") {
      this.handleTakeSurvey()
    }
  }*/

  /**
   * This method is used to handle terms popup close
   *
   */
  handleTermsClose = () => {
    this.setState(
      {
        isTermsVisible: false,
      },
      () => {
        if (sessionStorage.getItem("before-login-consent")) {
          sessionStorage.removeItem("before-login-consent");
        }
      }
    );
  };

  handleCartClick = (e?: any) => {
    this.setState({
      isCartVisible: true,
    });
  };
  handleCartClose = () => {
    this.setState({
      isCartVisible: false,
    });
  };

  /**
   * This method is used to handle pick survey popup close
   *
   */
  handlePickSurveyClose = () => {
    this.setState({
      isPickSurveyVisible: false,
    });
  };

  /**
   * Used to display conditional Ui for assessment Button
   * Only visible -- if User is log in and an ABO
   */
  handleShareLinkVisibility = () => {
    let userInfoData = localStorage.getObj("user-info");

    // TEMP OVERRIDE (2026-09-02): forcing Share Assessment visible for everyone
    // while the Gluu/MDMS additionalAudience access issue is unresolved on
    // Amway's side (accountSubType isn't reliably populating). Remove the
    // `true ||` below once that's confirmed fixed to restore normal behavior.
    if (
      true ||
      (userInfoData &&
      userInfoData?.partyId &&
      userInfoData?.accountSubType?.toLowerCase() === "businessowner")
    ) {
      this.setState({
        isShareVisible: true,
      });
    } else {
      this.setState({
        isShareVisible: false,
      });
    }
  };

  /**
   * Used for text change for conditional navigation
   * Text = go to result, only if the assesment done
   */
  handleAssesmentDoneButtonText = () => {
    let recoResult = localStorage.getObj("reco-result");
    let foundationalCount = sessionStorage.getItem("foundationalPageCount");
    if (recoResult) {
      this.setState({
        isAssessmentDone: true,
        isAssessmentContinued: false,
      });
    } else if (foundationalCount) {
      this.setState({
        isAssessmentContinued: true,
        isAssessmentDone: false,
      });
    } else {
      this.setState({
        isAssessmentDone: false,
      });
    }
  };

  // isOS = () => {
  //   return navigator.userAgent.match(/ipad|iphone/i);
  // }
  /**
   * This function associated with the shareAssesment Button
   * Only works as per button visibility condition
   */

  handleShareAssessment = async () => {
    await getShareableLink().then((res: any) => {
      if (res?.data?.sharableLink) {
        //console.log("link copied..");
        let browserDetection: boolean =
          navigator.userAgent.search("Safari") >= 0 &&
          navigator.userAgent.search("Chrome") < 0;

        this.setState({
          linkToBeCopied: res?.data?.sharableLink,
          isCopLinkPopUpOpen: true,
          isPopupOpen: true,
        });
      }
    });
  };

  handleAssessmentClick = (value: boolean) => {
    if (value) {
      this.setState({
        isTermsVisible: true,
      });
    } else {
      this.setState(
        {
          isTermsVisible: false,
        },
        () => {
          this.props.history.push("/foundational");
        }
      );
    }
    // let recoResult = localStorage.getObj("reco-result");
    // if (recoResult && !_.isEmpty(recoResult?.data?.getRecommendation)) {
    //   this.setState({
    //     isAssessmentDone: true,
    //   });
    // } else {
    //   this.setState({
    //     isAssessmentDone: false,
    //   });
    // }
    // this.setState({
    //   isCartVisible: true,
    // });
  };

  /**
   * This method is used to get content from content stack
   * @param {string} contentTypeId
   *
   */
  getContentForComponent = (contentTypeId: string) => {
    return getContentFromContentStack(contentTypeId)
      .then((response) => {
        if (response && response.error_message) {
          this.setState({
            errorMsg: response,
          });
        } else {
          return response && response[0];
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  /**
   * This method is used to get home page data from content stack
   * @param {string} contentTypeId
   *
   */
  getHomePageData = async (contentTypeId: any) => {
    let result: any;
    result = await this.getContentForComponent(contentTypeId);
    let Obj: any = {};
    Obj.content = result && result[0];

    let cardObj: any = {};
    cardObj = result && result[0] && result[0].wellness_persona.card;

    let scientistsObj: any = {};
    scientistsObj =
      result && result[0] && result[0].meet_our_nutritionist.scientists;

    this.setState({
      homePageContents: [Obj],
      cardContent: cardObj,
      scientistsContent: scientistsObj,
    });
  };

  closePopup = (e: any) => {
    if (e?.target?.accessKey === "copyClicked") {
      this.setState(
        {
          successfullyCopied: true,
        },
        () =>
          setTimeout(() => this.setState({ successfullyCopied: false }), 3000)
      );
    }
    this.setState(
      {
        isPopupOpen: false,
        // showPopup: false,
      },
      () => {
        sessionStorage.removeItem("session-cleared");

        //if user denied to relogin then session gets cleared
        if (sessionStorage.getItem("login-session-expired")) {
          let currentLanguage =
            sessionStorage.getItem("languageTypeOfApp") || "en-us";
          localStorage.clear();
          sessionStorage.clear();
          sessionStorage.setItem("languageTypeOfApp", currentLanguage);
          localStorage.setItem("logout", "true");
        }
        window.location.reload();
      }
    );
  };

  // componentWillReceiveProps(props: any) {
  //   validateOktaSession(this.props.oktaAuth);
  //   if (sessionStorage.getItem("login-session-expired")) {
  //     this.setState({
  //       isSessionExpired: true,
  //       isPopupOpen: true,
  //     });
  //   }

  //   //getContentFormComponenet function is called here
  //   if (props && props.i18n.language) {
  //     this.getHomePageData("ms_home_page");
  //   }
  // }

  /**
   * This function is used to handle change in header selection
   * @data - any
   *
   */

  handleHeaderSelection = (data: any) => {
    const storageData = localStorage.getObj("results");
    if (data === "Tips") {
      if (
        sessionStorage.getItem("languageTypeOfApp") !== null &&
        sessionStorage.getItem("languageTypeOfApp") !==
          localStorage.getItem("results-language")
      ) {
        this.props.history.push("/results", { data: storageData });
      } else {
        this.props.history.push("/summary/#tips", {
          summaryType: "Tips",
          data: storageData,
        });
      }
    }
    if (data === "Foods") {
      if (
        sessionStorage.getItem("languageTypeOfApp") !== null &&
        sessionStorage.getItem("languageTypeOfApp") !==
          localStorage.getItem("results-language")
      ) {
        this.props.history.push("/results", { data: storageData });
      } else {
        this.props.history.push("/summary/#foods", {
          summaryType: "Foods",
          data: storageData,
        });
      }
    }
    if (data === "Products") {
      if (
        sessionStorage.getItem("languageTypeOfApp") !== null &&
        sessionStorage.getItem("languageTypeOfApp") !==
          localStorage.getItem("results-language")
      ) {
        this.props.history.push("/results", { data: storageData });
      } else {
        this.props.history.push("/summary/#products", {
          summaryType: "Products",
          data: storageData,
        });
      }
    }
    if (data === "Results") {
      this.props.history.push("/results", { data: storageData });
    }
  };

  handleSelectSurvey = (surveyType: any) => {
    localStorage.setItem("surveyType", surveyType);
    this.setState({
      isPickSurveyVisible: false,
    });
    let userConsentFlag: any = localStorage.getObj("user-consent");
    if (!this.state.isAssessmentDone) {
      // Call for Term and condition
      if (userConsentFlag && userConsentFlag === "accepted") {
        this.setState({
          isTermsVisible: false,
        });
        this.props.history.push("/foundational");
      } else {
        this.setState({
          isTermsVisible: true,
        });
      }
      // this.props.history.replace("/terms");
    } else if (this.state.isAssessmentContinued) {
      //handles continue assessment
      this.props.history.push("/foundational");
    } else {
      // call for the result page.

      //sets save result popup time for guest user
      if (!localStorage.getItem("okta-token-storage")) {
        setGuestSaveResultTime();
      }
      if (userConsentFlag && userConsentFlag === "accepted") {
        const storageData = localStorage.getObj("results");
        // this.props.history.push("/results");
        this.props.history.push("/results", { data: storageData });
      } else {
        localStorage.removeItem("reco-result");
        this.setState({
          isTermsVisible: true,
        });
      }
    }
  };

  render() {
    const language = sessionStorage.getItem("languageTypeOfApp") || "en-us";
    const ProfileCardSettings = {
      dots: true,
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: true,
      dotsClass: "slick-dots slick-thumb",
    };

    const {
      isCartVisible,
      isShareVisible,
      isAssessmentDone,
      isAssessmentContinued,
      successfullyCopied,
      homePageContents,
      cardContent,
      visibleOnMobile,
      scientistsContent,
    } = this.state;

    const {
      survey_banner,
      how_it_works,
      wellness_persona,
      signs_block,
      meet_our_nutritionist,
      final_cta_banner,
      explore_more,
    } =
      (homePageContents &&
        homePageContents[0] &&
        homePageContents[0].content) ||
      {};

    //   let isAssessmentDone = localStorage.getObj("reco-result");
    // let isAssessmentContinued = parseInt(sessionStorage.getItem("foundationalPageCount") || "")
    let isConsentAccepted = localStorage.getItem("user-consent");
    return (
      <div
        className={
          this.state.isTermsVisible
            ? "home-container no-scroll"
            : "home-container"
        }
      >
        <a className="skip-link" href="#skip-to-take-survey-btn">
          {isAssessmentContinued && !isAssessmentDone
            ? this.props.t("common.skip_to_keep_going")
            : isAssessmentDone
            ? this.props.t("common.skip_to_my_results")
            : this.props.t("common.skip_to_take_survey")}
        </a>
        {/* Add to Cart Success Message Start */}
        {successfullyCopied ? (
          <MessageStrip messageText={this.props.t("common.link_copied")} />
        ) : null}
        {this.state.isCopLinkPopUpOpen && (
          <SaveResultsPopup
            {...this.props}
            open={this.state.isPopupOpen}
            close={this.closePopup}
            popupTitle={this.props.t("common.link_popup_title")}
            popupMessage={this.state.linkToBeCopied}
            popupFirstButton={false}
            popupFirstButtonType="linkshare"
          />
        )}

        {/* Focus Path Start */}
        {this.state.isPickSurveyVisible && (
          <PickSurveyComponent
            {...this.props}
            show={this.state.isPickSurveyVisible}
            handleClose={this.handlePickSurveyClose}
            handleSelectSurvey={(surveyType: any) =>
              this.handleSelectSurvey(surveyType)
            }
          />
        )}
        {/* Focus Path Ends */}

        {/* Terms & Condition Start */}
        <TermsConditions
          {...this.props}
          show={this.state.isTermsVisible}
          handleClose={this.handleTermsClose}
        />
        {/* Terms & Condition Ends */}

        {/* Save Results Popup Start */}
        {this.state.isGuestTimeExpired && (
          <SaveResultsPopup
            {...this.props}
            open={this.state.isPopupOpen}
            close={this.closePopup}
            popupTitle={this.props.t("common.welcome_back")}
            popupMessage={this.props.t("common.guest_expiry_message")}
            popupFirstButton={this.props.t("common.sign_in")}
            popupFirstButtonType="sign-in"
            // popupSecondButton="Take the Quiz"
          />
        )}

        {this.state.isSessionExpired && (
          <SaveResultsPopup
            {...this.props}
            open={this.state.isPopupOpen}
            close={this.closePopup}
            popupTitle={this.props.t("common.welcome_back")}
            popupMessage={this.props.t("common.login_session_expiry_message")}
            popupFirstButton={this.props.t("common.sign_in")}
            popupFirstButtonType="sign-in"
            // popupSecondButton="Take the Quiz"
          />
        )}
        {/* Save Results Popup Ends */}

        {/* Cart Component Start */}
        {isCartVisible ? (
          <CartComponent
            {...this.props}
            handleClose={this.handleCartClose}
            show={isCartVisible}
          />
        ) : null}
        {/* Cart Component Ends */}

        {/* Feedback button Start */}
        {/* <div className="feedback-button-wrapper">
           <div className="label">Feedback</div>
         </div> */}
        {/* Feedback button Ends */}
        {/* Header Container Start */}
        <div className="header-container">
          <ResultsHeader
            {...this.props}
            handleCallBack={(data: any) => this.handleHeaderSelection(data)}
            handleAssessmentClick={this.handleTakeSurvey}
            handleCartClick={this.handleCartClick}
            handleCartKeyPress={(e: any) => {
              if (e.key === "Enter") {
                this.handleCartClick(e);
              }
            }}
          />

          <div className="banner-bg-container">
            <div
              className="icon banner-bg-img"
              style={{
                backgroundImage: visibleOnMobile
                  ? `url(${process.env.REACT_APP_MB_SURVEY_BANNER})`
                  : `url(${process.env.REACT_APP_SURVEY_BANNER})`,
              }}
            ></div>
            {/* Result User Info Start */}
            <div className="banner-title-wrapper">
              <div className="heading">{survey_banner?.title}</div>
              <div className="details">{survey_banner?.subtitle}</div>
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                }}
              >
                <div
                  tabIndex={0}
                  className="take-survey-btn"
                  id="skip-to-take-survey-btn"
                >
                  <Button
                    name={
                      isAssessmentContinued &&
                      !isAssessmentDone &&
                      isConsentAccepted
                        ? this.props.t("common.keep_going")
                        : isAssessmentDone && isConsentAccepted
                        ? this.props.t("common.go_to_my_result")
                        : this.props.t("common.take_survey")
                    }
                    className="app-btn"
                    onButtonClick={this.handleTakeSurvey}
                    //onKeyPress={this.handleTakeSurveyOnKeyPress}
                  />
                </div>
                {isShareVisible ? (
                  <div className="share-assessment-btn">
                    <Button
                      name={this.props.t("common.share_assessment")}
                      className="app-btn"
                      onButtonClick={this.handleShareAssessment}
                    />
                  </div>
                ) : null}
              </div>
            </div>
            <div className="banner-details-container">
              <span className="vertical-line"></span>
              <div className="works-wrapper">
                <div className="title">{how_it_works?.title}</div>
                <div className="details">
                  {ReactHtmlParser(how_it_works?.subtitle[0])}
                </div>
              </div>
              <div className="steps-wrapper">
                <div className="step">
                  <div className="count">1</div>
                  <div className="description">
                    {ReactHtmlParser(how_it_works?.subtitle[1])}
                  </div>
                </div>
                <div className="step">
                  <div className="count">2</div>
                  <div className="description">
                    {ReactHtmlParser(how_it_works?.subtitle[2])}
                  </div>
                </div>
                <div className="step">
                  <div className="count">3</div>
                  <div className="description">
                    {ReactHtmlParser(how_it_works?.subtitle[3])}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* Header Container Ends */}

        {/* middle area Start */}
        <div className="middle-area">
          {/* Your wellness Start */}
          <div className="your-wellness-container  bootstrap-wrapper">
            <div className="inner-wrapper col-md-12 clearfix">
              <div className="left-container col-md-6 pull-left">
                <div className="details-area">
                  <div className="heading">{wellness_persona?.title}</div>
                  <div className="detail">{wellness_persona?.subtitle}</div>
                  <div className="btn-wrapper">
                    <div className="take-survey-btn">
                      <Button
                        name={
                          isAssessmentContinued &&
                          !isAssessmentDone &&
                          isConsentAccepted
                            ? this.props.t("common.keep_going")
                            : isAssessmentDone && isConsentAccepted
                            ? this.props.t("common.go_to_my_result")
                            : this.props.t("common.take_survey")
                        }
                        className="app-btn"
                        onButtonClick={this.handleTakeSurvey}
                      />
                    </div>
                    {/* <div className="take-survey-btn">
                       <Button
                         name={"Tell a Friend"}
                         className="app-btn border-btn"
                         onButtonClick={() => {}}
                       />
                     </div> */}
                  </div>
                </div>
              </div>
              <div className="right-container col-md-6 pull-left">
                <div className="profile-area">
                  {/* profile Card Start */}
                  <Slider {...ProfileCardSettings}>
                    {cardContent &&
                      Object.values(cardContent).map((cardData: any) => (
                        <div className="profile-card">
                          <div className="profile-img">
                            <img
                              className="user-img"
                              src={cardData.image.url}
                              alt="profile"
                            />
                          </div>
                          <div className="profile-detail-wrapper">
                            <div className="profile-name">{cardData.title}</div>
                            <div className="profile-details">
                              {cardData.subtitle}
                            </div>
                            {cardData &&
                              cardData.list &&
                              Object.values(cardData.list).map(
                                (listItem: any) => (
                                  <div className="profile-lists">
                                    <ul>
                                      <li className="list">
                                        <span className="icon list-icon">
                                          {ReactHtmlParser(listItem[1])}
                                        </span>
                                        {ReactHtmlParser(listItem[0])}
                                      </li>
                                    </ul>
                                  </div>
                                )
                              )}
                            {cardData.card_disclaimer &&
                              cardData.card_disclaimer.length > 0 && (
                                <div className="disclaimer-wrapper">
                                  {cardData.card_disclaimer.map(
                                    (point: any) => (
                                      <div className="point">
                                        {ReactHtmlParser(point) || ""}
                                      </div>
                                    )
                                  )}
                                </div>
                              )}
                          </div>
                        </div>
                      ))}
                  </Slider>
                  {/* profile Card Ends */}
                </div>
                <div className="outer-disclaimer">
                  {wellness_persona?.outer_disclaimer}
                </div>
              </div>
            </div>
          </div>
          {/* Your wellness Ends */}
          {/* You got this Start */}
          <div
            className="you-got-wrapper"
            style={{
              backgroundImage: visibleOnMobile
                ? `url(${process.env.REACT_APP_MB_SIGNS_BLOCK})`
                : `url(${process.env.REACT_APP_SIGNS_BLOCK})`,
              // backgroundImage: `url(${process.env.REACT_APP_SIGNS_BLOCK})`,
            }}
          >
            <div className="heading">{signs_block?.title}</div>
            <div className="details">{signs_block?.subtitle}</div>
          </div>
          {/* You got this Ends */}
          {/* our nutritionist Start */}
          <div
            className="our-nutritionist-container"
            // style={{
            //   backgroundImage: visibleOnMobile
            //     ? `url(${process.env.REACT_APP_MB_NUTRITIONIST})`
            //     : `url(${process.env.REACT_APP_NUTRITIONIST})`,
            // }}
          >
            <div className="inner-wrapper">
              <div className="left-wrapper bootstrap-wrapper">
                <div className="our-scientists-contaier row col-md-12 clearfix">
                  {scientistsContent &&
                    Object.values(scientistsContent).map(
                      (scientistsData: any) => (
                        <div className="scientists-wrapper col-6 col-lg-4 pull-left">
                          <div className="profile-img">
                            <img
                              className="scientists-img"
                              src={scientistsData?.image?.url}
                              alt="profile"
                            />
                          </div>
                          <div className="name">{scientistsData?.name}</div>
                          <div className="designation">
                            {scientistsData?.designation}
                          </div>
                        </div>
                      )
                    )}
                </div>
              </div>
              <div className="right-wrapper">
                <div className="details-wrapper">
                  <div className="heading">{meet_our_nutritionist?.title}</div>
                  <div className="sub-title">
                    {meet_our_nutritionist?.subtitle}
                  </div>
                </div>
                <div className="nutritionist-details">
                  {/* <div className="name">
                    {meet_our_nutritionist?.nutritionist?.title}
                  </div>
                  <div className="designation">
                    {meet_our_nutritionist?.nutritionist?.subtitle}
                  </div> */}
                  <div className="description">
                    {meet_our_nutritionist?.nutritionist?.description}
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* our nutritionist Ends */}
          {/* your wellness journey Start */}
          <div
            className="journey-start-container"
            style={{
              backgroundImage: visibleOnMobile
                ? `url(${process.env.REACT_APP_MB_CTA_BANNER})`
                : `url(${process.env.REACT_APP_CTA_BANNER})`,
            }}
          >
            <div className="inner-wrapper">
              <div className="heading">{final_cta_banner?.title}</div>
              <div className="sub-title">{final_cta_banner?.subtitle}</div>
              <div className="take-survey-btn">
                <Button
                  name={
                    isAssessmentContinued &&
                    !isAssessmentDone &&
                    isConsentAccepted
                      ? this.props.t("common.keep_going")
                      : isAssessmentDone && isConsentAccepted
                      ? this.props.t("common.go_to_my_result")
                      : this.props.t("common.get_started")
                  }
                  className="app-btn"
                  onButtonClick={this.handleTakeSurvey}
                />
              </div>
            </div>
          </div>
          {/* your wellness journey Ends */}
          {/* explore more Start */}
          <div className="explore-more-container">
            <div className="heading">{explore_more?.title}</div>
            <div className="details">{explore_more?.subtitle}</div>
            <div className="company-logo">
              <div
                className="icon nutrilite-logo"
                style={{
                  backgroundImage: explore_more?.icons?.[0]
                    ? `url(${explore_more.icons[0]})`
                    : `url("")`,
                }}
                onClick={() => {
                  window.open(
                    `${process.env.REACT_APP_NUTRILITE_LOGO}`?.replaceAll(
                      "language",
                      getLanguage() || ""
                    ),
                    "_blank"
                  );
                }}
              ></div>
              <div
                className="icon xs-logo"
                style={{
                  backgroundImage: explore_more?.icons?.[1]
                    ? `url(${explore_more.icons[1]})`
                    : `url("")`,
                }}
                onClick={() => {
                  window.open(
                    `${process.env.REACT_APP_XS_LOGO}`?.replaceAll(
                      "language",
                      getLanguage() || ""
                    ),
                    "_blank"
                  );
                }}
              ></div>
            </div>
          </div>
          {/* explore more Ends */}
        </div>
        {/* middle area Ends */}

        {/* Footer Section Start */}
        <Footer {...this.props} />
        {/* Footer Section Ends */}
      </div>
    );
  }
}

export default withOktaAuth(HomeComponent);
